<template>
    <div>
        <el-select
            v-model="selectItem"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="getProcessCommonUseConfigList"
            :loading="loading" 
            @change="selectTrigger">
            <el-option
                v-for="item in processCommonUseConfigList"
                :key="item.id"
                :label="item.processInstanceName"
                :value="item.id">
            </el-option>
        </el-select>
    </div>
</template>

<script>
    import { getProcessCommonUseConfigList } from '@/data-model';

    export default {
        data () {
            return {
                loading: false,
                processCommonUseConfigList: [],
                selected: {
                    id: '',
                    processInstanceName: ''
                },
                selectItem: ''
            };
        },
        props: {
            processServiceId: {
                type: String,
                required: true
            },
            deploymentId: {
                type: String,
                required: true
            }
        },
        created () {
            this.getProcessCommonUseConfigList();
        },
        methods: {
            async getProcessCommonUseConfigList () {
                this.loading = true;
                let data = await getProcessCommonUseConfigList({
                    processServiceId: this.processServiceId,
                    deploymentId: this.deploymentId
                });
                this.processCommonUseConfigList = data.data;
                this.loading = false;
            },
            selectTrigger (val) {
                if (val) {
                    this.selected = this.processCommonUseConfigList.find((item) => {
                        return item.id === val;
                    });
                } else {
                    this.selected = {id: '', processInstanceName: '', taskConfigInfo: []};
                }
                this.$emit('nodeClick', {taskConfigInfo: this.selected.taskConfigInfo});
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/ProcessCommonUseConfigSelect/ProcessCommonUseConfigSelect.vue